<template>
    <div class="app-container">
        <notifications position="bottom center" width="320px" classes="vue-notification" />

        <ProgressBar />

        <GlobalNavigation
            v-if="!allQuestionsDone && !isMobile"
            :questions="questions"
            :currentQuestionId="currentQuestionId"
            @navigation-change="handleNavigationChange"
        />

        <Transition name="fade" mode="out-in" appear>
            <WizardFinished v-if="allQuestionsDone" />

            <InformationScreen
                v-else-if="currentQuestion.id === 1"
                :question="currentQuestion"
                @accepted="handleUserAnswered"
            />
            <YesNoAnswer
                v-else-if="currentQuestion.id === 2"
                :question="currentQuestion"
                @answered="handleUserAnswered"
            />
            <YesNoAnswer
                v-else-if="currentQuestion.id === 3"
                :question="currentQuestion"
                @answered="handleUserAnswered"
            />           
            <GatedMultipleChoiceWithAdditionalAnswers
                v-else-if="currentQuestion.id === 4"
                :question="currentQuestion"
                @answered="handleUserAnswered"
            />
            <MultipleChoiceWithTitleAndTextWithAdditionalAnswers
                v-else-if="currentQuestion.id === 5"
                :question="currentQuestion"
                @answered="handleUserAnswered"
            />
            <MultipleChoiceWithTitleAndTextWithAdditionalAnswers
                v-else-if="currentQuestion.id === 6"
                :question="currentQuestion"
                @answered="handleUserAnswered"
            />
            <TextAnswer
                v-else-if="currentQuestion.id === 7"
                :question="currentQuestion"
                @answered="handleUserAnswered"
            />
            <GatedTextAnswer
                v-else-if="currentQuestion.id === 8"
                :question="currentQuestion"
                @answered="handleUserAnswered"
            />
            <GatedTextAnswer
                v-else-if="currentQuestion.id === 9"
                :question="currentQuestion"
                @answered="handleUserAnswered"
            />
            <GatedTextAnswer
                v-else-if="currentQuestion.id === 10"
                :question="currentQuestion"
                @answered="handleUserAnswered"
            />
            <TextAnswer
                v-else-if="currentQuestion.id === 11"
                :question="currentQuestion"
                @answered="handleUserAnswered"
            />
        </Transition>

       <RestartWizard
       @restart="handleRestart()"
       />

        <GlobalNavigation
            v-if="!allQuestionsDone && isMobile"
            :questions="questions"
            :currentQuestionId="currentQuestionId"
            @navigation-change="handleNavigationChange"
        />
    </div>
</template>

<script setup>
import { computed, ref, onBeforeMount, onBeforeUnmount } from 'vue';
import { questions } from './questions';
import InformationScreen from './components/questionTypes/InformationScreen.vue';
import YesNoAnswer from './components/questionTypes/YesNoAnswer.vue';
import GatedMultipleChoiceWithAdditionalAnswers from './components/questionTypes/GatedMultipleChoiceWithAdditionalAnswers.vue';
import MultipleChoiceWithTitleAndTextWithAdditionalAnswers from './components/questionTypes/MultipleChoiceWithTitleAndTextWithAdditionalAnswers.vue';
import TextAnswer from './components/questionTypes/TextAnswer.vue';
import GatedTextAnswer from './components/questionTypes/GatedTextAnswer.vue';
import WizardFinished from './components/WizardFinished.vue';
import { LocalStorageService } from './services/LocalStorageService';
import GlobalNavigation from './components/GlobalNavigation.vue';
import ProgressBar from './components/ProgressBar.vue';
import RestartWizard from './components/RestartWizard.vue';
import { WIZARD_STATE_KEY_NAME } from './consts/localStorage';

const localStorageService = new LocalStorageService();



onBeforeMount(() => {
    const isStatePresent = localStorageService.getState();

    if (!isStatePresent) {
        localStorageService.setupLocalStorageState(questions);
    }

    allQuestionsDone.value = localStorageService
        .getState()
        .every(
            question =>                
                question.userConfirmed ||
                question.userAnswer?.length > 0 ||
                question.userAnswers?.some(answer => answer.selected)
        );

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', checkIsMobile);
});

const allQuestionsDone = ref(false);
const currentQuestionId = ref(1);
const isMobile = ref(false);

const currentQuestion = computed(() => questions.find(q => q.id === currentQuestionId.value));

const handleUserAnswered = () => {
    dispatchLocalsotrageChangeEvent();

    const firstUnfinishedQuestion = localStorageService.getState().find(question => 
    {
        return localStorageService.questionAnswered(question) === false;
    });

    if (firstUnfinishedQuestion) {
        return handleNavigationChange(firstUnfinishedQuestion.id);
    }

    allQuestionsDone.value = true;
};

const dispatchLocalsotrageChangeEvent = () => {
    window.dispatchEvent(
        new CustomEvent(`${WIZARD_STATE_KEY_NAME}-localstorage-changed`, {
            detail: {
                storage: localStorageService.getState()
            }
        })
    );
};

const handleNavigationChange = questionid => {
    dispatchLocalsotrageChangeEvent();
    currentQuestionId.value = questionid;
    var url = '/personvernerklaeringsgenerator-' + questionid
    history.pushState({"qId" : questionid}, null, url)
};

const navigateToFirstQuestion = () => {
    handleNavigationChange(questions[0].id);
};

const resetQuestionState = () => {    
    localStorageService.clearState();
    localStorageService.setupLocalStorageState(questions);
    allQuestionsDone.value = false;
};

const handleRestart = () => {   
    resetQuestionState();    
    navigateToFirstQuestion();
};

const checkIsMobile = () => {
    if (window.screen.width < 600) {
        isMobile.value = true;
    } else {
        isMobile.value = false;
    }
};
</script>
